import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import MenuIcon from '@mui/icons-material/Menu';
import PushPinIcon from '@mui/icons-material/PushPin';
import PushPinOutlinedIcon from '@mui/icons-material/PushPinOutlined';
import { Collapse, Tooltip } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
//import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { useTheme } from '@mui/material/styles';
// import Typography from '@mui/material/Typography';
// import { ThemeProvider } from '@mui/styles';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
// import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

import { ROLES } from '../../../config';
// ! I remove it from package.json bcs it takes too much time to build and load on docker
//     "@mui/icons-material": "^4.11.3",
// import {
//     ExpandLess, ExpandMore,
//     // StarBorder
// } from '@mui/icons-material';
import LogoLight from '../../../data/LogoLight';
import useAuth from '../../../hooks/useAuth';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
// import useLogout from '../../../hooks/useLogout';
import useRole from '../../../hooks/useRole';
import useUtilities from '../../../hooks/useUtilities';
import useWindowSize from '../../../hooks/useWindowSize';
// import { FontLinkNavBar } from '../../../Styles/componentStyles';
import navbarListAdmin, { navbarListAdminChargeRecrutement } from './navListAdmin';
import navbarListClient from './navListClient';
import navbarListEsn from './navListEsn';
import getNavbarListExpert from './navListExpert';

const drawerWidthOpen = 267; //was 240 px
const paddingIconButton = 10;
const marginIconButton = 14;
const iconFontSize = 20;
const drawerWidthClose = (paddingIconButton + marginIconButton) * 2 + iconFontSize + 10; // =78
// export var StateNa=['foo'];

export default function SideNavbar() {
    // conditional rendering on the sideBar Expert Vs Client
    const { auth } = useAuth();
    const role = useRole();
    const { device } = useWindowSize();
    const axiosPrivate = useAxiosPrivate();
    const [inviterEsnId, setInviterEsnId] = useState(null);
    const { i18n } = useTranslation();
    const { sideBarOpen, setSideBarOpen } = useUtilities();
    const theme = useTheme();
    const [navbarListGlobal, setnavbarListGlobal] = useState([]);
    const [permissionToHide, setPermissionToHide] = useState(false);
    //const refFocus = useRef();
    const [openNestedItem1, setOpenNestedItem1] = useState([
        // We have 4 now 6 expanded items
        // ! this logic , doesn't work well ,
        // ! especially with handleClick1() logic ,, see console 4 more details
        //! pb similaire .. https://stackoverflow.com/questions/52108216/react-material-ui-multiple-collapse
        // { 2: false },
        // { 3: false },
        // { 4: false },
        // { 5: false },
        // { 6: false },
        // { 7: false },
    ]);

    const [isPinned, setIsPinned] = useState(
        localStorage.getItem('sideMenuPinned') === 'true'
    );

    useEffect(() => {
        localStorage.setItem('sideMenuPinned', isPinned);
    }, [isPinned]);

    useEffect(() => {
        if (auth.roles == ROLES.Client)
            setnavbarListGlobal(navbarListClient);
        if (auth.roles == ROLES.Expert && inviterEsnId != null)
            setnavbarListGlobal(getNavbarListExpert(inviterEsnId));
        if (auth.roles == ROLES.Esn)
            setnavbarListGlobal(navbarListEsn);
    }, [inviterEsnId]);

    useEffect(() => {
        if (auth.roles == ROLES.Admin) {
            if (permissionToHide == true)
                setnavbarListGlobal(navbarListAdminChargeRecrutement);
            else
                setnavbarListGlobal(navbarListAdmin);
        }
    }, [permissionToHide]);

    useEffect(() => {
        if (role && (auth.roles == ROLES.Admin || auth.roles == ROLES.Expert))
            getMyInfos();
    }, [auth, role]);

    useEffect(() => {
        console.log('inviterEsnId', inviterEsnId, 'navbarListGlobal', navbarListGlobal);
    }, [inviterEsnId, navbarListGlobal]);

    const getMyInfos = async () => {
        try {
            const response = await axiosPrivate.get(`${role}/getMyInfos`);
            if ((response.data?.backOffice?.roles?.chargeRecrutement == 1)) {
                setPermissionToHide(true);
            }
            setInviterEsnId(response?.data?.expert?.esnId ? true : false);
        } catch (error) {
            console.log(error);
        }
    };

    function toogleOpen() {
        if (isPinned) {
            return;
        }
        setSideBarOpen(!sideBarOpen);
        console.log(!sideBarOpen);
        if (!sideBarOpen) {
            setOpenNestedItem1(false);
        }
    }

    const navigate = useNavigate();

    const effectiveSideBarOpen = isPinned ? false : sideBarOpen;

    const drawerContent = (
        <>
            <Box
                sx={{
                    display: 'flex',
                    width: '267px',
                    backgroundColor: 'transparent',
                    padding: '24px 24px',
                    alignItems: 'flex-end',
                }}
            >
                <Box
                    sx={{
                        flexShrink: 0,
                        display: sideBarOpen ? 'none' : { xs: 'initial', sm: 'initial' },
                    }}
                >
                    <LogoLight />
                </Box>
                <Button
                    onClick={toogleOpen}
                    sx={{
                        minWidth: 'initial',
                        padding: '4px',
                        color: 'gray',
                        marginLeft: sideBarOpen ? '10px' : '70px',
                        backgroundColor: 'transparent',
                        '&:hover': {
                            backgroundColor: '#26284687',
                        },
                    }}
                >
                    <MenuIcon
                        sx={{
                            color: 'white',
                            fontFamily: 'Lato',
                            fontStyle: 'normal',
                            fontWeight: '400',
                            fontSize: '14px',
                            lineHeight: '24px',
                            letterSpacing: '-0.0044em',
                        }}
                    />
                </Button>
                <Button
                    onClick={() => setIsPinned(!isPinned)}
                    sx={{
                        minWidth: 'initial',
                        padding: '4px',
                        marginLeft: '8px',
                        backgroundColor: 'transparent',
                        '&:hover': {
                            backgroundColor: '#26284687',
                        },
                    }}
                >
                    {isPinned ? (
                        <PushPinIcon
                            sx={{
                                color: 'white',
                                fontSize: '20px',
                            }}
                        />
                    ) : (
                        <PushPinOutlinedIcon
                            sx={{
                                color: 'white',
                                fontSize: '20px',
                            }}
                        />
                    )}
                </Button>
            </Box>
            <List
                dense={true}
                sx={{
                    color: 'white !important',
                    paddingLeft: '10px',
                    marginTop: '-18px',
                    borderRadius: '8px',
                    '&:hover': { color: 'red' },
                }}
            >
                {navbarListGlobal.map((key, index) => {
                    const isCurrentOpen = openNestedItem1[index] || false; // Default to false if not defined

                    return (
                        <React.Fragment key={index}>
                            <Tooltip title={sideBarOpen ? i18n.t(key.desc) : ''}>
                                <ListItemButton
                                    onClick={() => {
                                        if (key.subList.length === 0) {
                                            // If there's no sublist, navigate directly
                                            navigate(`/${role}/${key.link}`);
                                            setSideBarOpen(true); // Close the sidebar
                                            setOpenNestedItem1({}); // Reset all open states
                                        } else {
                                            // Otherwise, toggle submenu open state
                                            const newOpenState = { [index]: !isCurrentOpen };
                                            setOpenNestedItem1(prev => ({
                                                ...newOpenState,
                                                ...Object.fromEntries(
                                                    Object.keys(prev)
                                                        .filter(k => k !== index.toString())
                                                        .map(k => [k, false]) // Close other items
                                                ),
                                            }));
                                        }
                                    }}
                                    sx={{
                                        margin: '6px 14px',
                                        color: 'white',
                                        fontSize: '15px',
                                        lineHeight: '24px',
                                        letterSpacing: '-0.0044em',
                                        padding: '10px',
                                        borderRadius: '8px',
                                        '&:hover': { backgroundColor: '#26284687' },
                                    }}
                                >
                                    <ListItemIcon sx={{ width: '22px', height: '19px', minWidth: sideBarOpen ? '45px' : '34px' }}>
                                        <div
                                            style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                                            onClick={e => {
                                                e.stopPropagation(); // Prevent parent button click from firing
                                                if (sideBarOpen) {
                                                    setSideBarOpen(false); // Open the sidebar
                                                }
                                                // Toggle the parent item
                                                const newOpenState = {
                                                    [index]: !isCurrentOpen // Toggle current item's open state
                                                };
                                                setOpenNestedItem1(prev => ({
                                                    ...newOpenState,
                                                    ...Object.fromEntries(
                                                        Object.keys(prev)
                                                            .filter(k => k !== index.toString())
                                                            .map(k => [k, false]) // Close all other open items
                                                    )
                                                }));
                                            }}
                                        >
                                            <key.icon sx={{ color: 'white' }} />
                                        </div>
                                    </ListItemIcon>
                                    <ListItemText
                                        primary={i18n.t(key.desc)}
                                        sx={{ color: 'white' }}
                                    />
                                    {key.badge !== 0 &&
                                        <Chip
                                            label={key.badge}
                                            color={'secondary'}
                                            size="small"
                                            sx={{ height: 'auto' }}
                                        />
                                    }
                                    {key.subList.length > 0 && (isCurrentOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />)}
                                </ListItemButton>
                            </Tooltip>

                            {key.subList.length > 0 && (
                                <Collapse
                                    in={isCurrentOpen}
                                    timeout="auto"
                                    unmountOnExit
                                >
                                    <List
                                        component="div"
                                        disablePadding
                                    >
                                        {key.subList.map((subKey, subIndex) => (
                                            <React.Fragment key={subIndex}>
                                                <ListItemButton
                                                    onClick={() => {
                                                        // If it's a submenu with further items, toggle it
                                                        const isSubOpen = openNestedItem1[index] && openNestedItem1[index][subIndex];
                                                        if (subKey.subList && subKey.subList.length > 0) {
                                                            setOpenNestedItem1(prev => ({
                                                                ...prev,
                                                                [index]: { ...prev[index], [subIndex]: !isSubOpen },
                                                            }));
                                                        } else {
                                                            // Navigate to the final link and close the sidebar
                                                            const link = `/${role}/${subKey.link}`;
                                                            navigate(link);
                                                            setSideBarOpen(true); // Close sidebar
                                                            setOpenNestedItem1({}); // Close all submenus
                                                        }
                                                    }}
                                                    sx={{ pl: 4 }}
                                                >
                                                    <ListItemText
                                                        primary={i18n.t(subKey.desc)}
                                                        sx={{ color: 'white' }}
                                                    />
                                                    {subKey.subList && subKey.subList.length > 0 && (openNestedItem1[index] && openNestedItem1[index][subIndex] ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />)}
                                                </ListItemButton>
                                                {/* Render sublist if it exists */}
                                                {subKey.subList && subKey.subList.length > 0 && (
                                                    <Collapse
                                                        in={openNestedItem1[index] && openNestedItem1[index][subIndex]}
                                                        timeout="auto"
                                                        unmountOnExit
                                                    >
                                                        <List
                                                            component="div"
                                                            disablePadding
                                                        >
                                                            {subKey.subList.map((subSubKey, subSubIndex) => (
                                                                <ListItemButton
                                                                    key={subSubIndex}
                                                                    onClick={() => {
                                                                        // Navigate to the sub-sub item and close the sidebar
                                                                        const subSubLink = `/${role}/${subSubKey.link}`;
                                                                        navigate(subSubLink);
                                                                        setSideBarOpen(true); // Close sidebar
                                                                        setOpenNestedItem1({}); // Close all submenus
                                                                    }}
                                                                    sx={{ pl: 8 }} // indent further for sub-sub items
                                                                >
                                                                    <ListItemText
                                                                        primary={i18n.t(subSubKey.desc)}
                                                                        sx={{ color: 'white' }}
                                                                    />
                                                                </ListItemButton>
                                                            ))}
                                                        </List>
                                                    </Collapse>
                                                )}
                                            </React.Fragment>
                                        ))}
                                    </List>
                                </Collapse>
                            )}
                        </React.Fragment>
                    );
                })}
            </List>
        </>
    );

    return (
        <Box>
            <Drawer
                variant="permanent"
                open={effectiveSideBarOpen}
                sx={{
                    fontFamily: 'Lato',
                    fontStyle: 'normal',
                    fontWeight: '400',
                    fontSize: '14px',
                    lineHeight: '24px',
                    /* identical to box height, or 150% */
                    letterSpacing: '-0.0044em',
                    width: isPinned
                        ? { xs: drawerWidthOpen, sm: drawerWidthOpen }
                        : sideBarOpen
                            ? { xs: '0px', sm: device == 'desktop' ? drawerWidthClose : '0px' }
                            : { xs: drawerWidthClose, sm: drawerWidthOpen },
                    transition: theme.transitions.create('width', {
                        easing: theme.transitions.easing.sharp,
                        duration: sideBarOpen
                            ? theme.transitions.duration.leavingScreen
                            : theme.transitions.duration.enteringScreen,
                    }),
                    '& .MuiDrawer-paper': {
                        fontFamily: 'Lato',
                        fontStyle: 'normal',
                        fontWeight: '400',
                        fontSize: '14px',
                        lineHeight: '24px',
                        /* identical to box height, or 150% */
                        letterSpacing: '-0.0044em',
                        display: 'flex',
                        flexDirection: 'column',
                        overflowX: 'hidden',
                        width: isPinned
                            ? { xs: drawerWidthOpen, sm: drawerWidthOpen }
                            : sideBarOpen
                                ? { xs: '0px', sm: device == 'desktop' ? drawerWidthClose : '0px' }
                                : { xs: drawerWidthOpen, sm: drawerWidthOpen },
                        borderRight: '0px',
                        boxShadow: theme.shadows[8],
                        backgroundColor: sideBarOpen ? '#214DCE' : '#214DCE',
                        transition: theme.transitions.create('width', {
                            easing: theme.transitions.easing.sharp,
                            duration: sideBarOpen
                                ? theme.transitions.duration.leavingScreen
                                : theme.transitions.duration.enteringScreen,
                        }),
                    },
                }}
            >
                {drawerContent}
            </Drawer>
        </Box>
    );
}
